import React, { useState } from "react";
import axios from "axios";

const ResetPassword = () => {
  const [newPassword, setNewPassword] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  // Get token from URL
  const params = new URLSearchParams(window.location.search);
  const token = params.get("token");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");
    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/auth/reset-password`,
        {
          token,
          newPassword,
        }
      );
      setMessage("Password reset successful. You can now log in.");
    } catch (err) {
      setMessage(
        err.response?.data?.message ||
          "Error resetting password. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div
        style={{
          maxWidth: 400,
          margin: "40px auto",
          padding: 24,
          border: "1px solid #eee",
          borderRadius: 8,
          textAlign: "center",
        }}
      >
        <h2>Reset Password</h2>
        <p>No reset token provided.</p>
      </div>
    );
  }

  return (
    <div
      style={{
        maxWidth: 400,
        margin: "40px auto",
        padding: 24,
        border: "1px solid #eee",
        borderRadius: 8,
        textAlign: "center",
      }}
    >
      <h2>Reset Password</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="password"
          placeholder="Enter new password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          required
          style={{ width: "100%", padding: 8, marginBottom: 16 }}
        />
        <button
          type="submit"
          disabled={loading}
          style={{ width: "100%", padding: 8 }}
        >
          {loading ? "Resetting..." : "Reset Password"}
        </button>
      </form>
      {message && <p style={{ marginTop: 16 }}>{message}</p>}
    </div>
  );
};

export default ResetPassword;
